import { Dispatch } from "redux";
import { ClassroomSizeConfig, ConfigPageIndex, FeederPatternConfig, SchoolDirectoryEntry, SeatLimitConfig, SiteConfigs } from "../../../domain/entities/Configs";
import DocumentTemplate from "../../../domain/entities/DocumentTemplate";
import Organization from "../../../domain/entities/Organization";
import Permission from "../../../domain/entities/Permission";
import { StateStatus } from "../../../domain/entities/State";
import User from "../../../domain/entities/User";
import AdministratorInteractor from "../../../domain/interactors/AdministratorInteractor";
import { ShapefileTag, ZoneShape } from "../../components/pages/ui-utils/zoneFilterTypes";
import { RootState } from "../reducers";

export enum ActionTypes {
  ORGANIZATIONS_LOAD_PROCESSING = "@administrator/ORGANIZATION_LOAD_PROCESSING",
  ORGANIZATIONS_LOAD_COMPLETE = "@administrator/ORGANIZATION_LOAD_COMPLETE",
  ORGANIZATIONS_LOAD_ERROR = "@administrator/ORGANIZATION_LOAD_ERROR",
  ORGANIZATIONS_SAVE_PROCESSING = "@administrator/ORGANIZATIONS_SAVE_PROCESSING",
  ORGANIZATIONS_SAVE_COMPLETE = "@administrator/ORGANIZATIONS_SAVE_COMPLETE",
  ORGANIZATIONS_SAVE_ERROR = "@administrator/ORGANIZATIONS_SAVE_ERROR",
  ORGANIZATIONS_GET_BYURL_PROCESSING = "@administrator/ORGANIZATIONS_GET_BYURL_PROCESSING",
  ORGANIZATIONS_GET_BYURL_COMPLETE = "@administrator/ORGANIZATIONS_GET_BYURL_COMPLETE",
  ORGANIZATIONS_GET_BYURL_ERROR = "@administrator/ORGANIZATIONS_GET_BYURL_ERROR",
  ORGANIZATION_GET_PROCESSING = "@administrator/ORGANIZATION_GET_PROCESSING",
  ORGANIZATION_GET_COMPLETE = "@administrator/ORGANIZATION_GET_COMPLETE",
  ORGANIZATION_GET_ERROR = "@administrator/ORGANIZATION_GET_ERROR",
  ORGANIZATION_GET_LOGIN_PROCESSING = "@administrator/ORGANIZATION_GET_LOGIN_PROCESSING",
  ORGANIZATION_GET_LOGIN_COMPLETE = "@administrator/ORGANIZATION_GET_LOGIN_COMPLETE",
  ORGANIZATION_GET_LOGIN_ERROR = "@administrator/ORGANIZATION_GET_LOGIN_ERROR",
  ORGANIZATION_DELETE_PROCESSING = "@administrator/ORGANIZATION_DELETE_PROCESSING",
  ORGANIZATION_DELETE_COMPLETE = "@administrator/ORGANIZATION_DELETE_COMPLETE",
  ORGANIZATION_DELETE_ERROR = "@administrator/ORGANIZATION_DELETE_ERROR",
  PERMISSION_SAVE_PROCESSING = "@administrator/PERMISSION_SAVE_PROCESSING",
  PERMISSION_SAVE_COMPLETE = "@administrator/PERMISSION_SAVE_COMPLETE",
  PERMISSION_SAVE_ERROR = "@administrator/PERMISSION_SAVE_ERROR",
  PERMISSIONS_LOAD_PROCESSING = "@administrator/PERMISSIONS_LOAD_PROCESSING",
  PERMISSIONS_LOAD_COMPLETE = "@administrator/PERMISSIONS_LOAD_COMPLETE",
  PERMISSIONS_LOAD_ERROR = "@administrator/PERMISSIONS_LOAD_ERROR",
  PERMISSIONTYPES_LOAD_PROCESSING = "@administrator/PERMISSIONTYPES_LOAD_PROCESSING",
  PERMISSIONTYPES_LOAD_COMPLETE = "@administrator/PERMISSIONTYPES_LOAD_COMPLETE",
  PERMISSIONTYPES_LOAD_ERROR = "@administrator/PERMISSIONTYPES_LOAD_ERROR",
  ROLES_LOAD_PROCESSING = "@administrator/ROLES_LOAD_PROCESSING",
  ROLES_LOAD_COMPLETE = "@administrator/ROLES_LOAD_COMPLETE",
  ROLES_LOAD_ERROR = "@administrator/ROLES_LOAD_ERROR",
  USER_SAVE_PROCESSING = "@administrator/USER_SAVE_PROCESSING",
  USER_SAVE_COMPLETE = "@administrator/USER_SAVE_COMPLETE",
  USER_SAVE_ERROR = "@administrator/USER_SAVE_ERROR",
  USER_COGNITO_SAVE_PROCESSING = "@administrator/USER_COGNITO_SAVE_PROCESSING",
  USER_COGNITO_SAVE_COMPLETE = "@administrator/USER_COGNITO_SAVE_COMPLETE",
  USER_COGNITO_SAVE_ERROR = "@administrator/USER_COGNITO_SAVE_ERROR",
  COGNITO_USER_CHECK_PROCESSING = "@administrator/COGNITO_USER_CHECK_PROCESSING",
  COGNITO_USER_CHECK_COMPLETE = "@administrator/COGNITO_USER_CHECK_COMPLETE",
  COGNITO_USER_CHECK_ERROR = "@administrator/COGNITO_USER_CHECK_ERROR",
  USER_DELETE_PROCESSING = "@administrator/USER_DELETE_PROCESSING",
  USER_DELETE_COMPLETE = "@administrator/USER_DELETE_COMPLETE",
  USER_DELETE_ERROR = "@administrator/USER_DELETE_ERROR",
  USER_LOAD_BY_EMAIL_PROCESSING = "@administrator/USER_LOAD_BY_EMAIL_PROCESSING",
  USER_LOAD_BY_EMAIL_COMPLETE = "@administrator/USER_LOAD_BY_EMAIL_COMPLETE",
  USER_LOAD_BY_EMAIL_ERROR = "@administrator/USER_LOAD_BY_EMAIL_ERROR",
  USER_REGISTER_PROCESSING = "@administrator/USER_REGISTER_PROCESSING",
  USER_REGISTER_COMPLETE = "@administrator/USER_REGISTER_COMPLETE",
  USER_REGISTER_ERROR = "@administrator/USER_REGISTER_ERROR",
  USERS_LOAD_PROCESSING = "@administrator/USERS_LOAD_PROCESSING",
  USERS_LOAD_COMPLETE = "@administrator/USERS_LOAD_COMPLETE",
  USERS_LOAD_ERROR = "@administrator/USERS_LOAD_ERROR",
  CONFIGS_LOAD_PROCESSING = "@administrator/CONFIGS_LOAD_PROCESSING",
  CONFIGS_LOAD_COMPLETE = "@administrator/CONFIGS_LOAD_COMPLETE",
  CONFIGS_LOAD_ERROR = "@administrator/CONFIGS_LOAD_ERROR",
  FATHER_CONFIGS_LOAD_PROCESSING = "@administrator/FATHER_CONFIGS_LOAD_PROCESSING",
  FATHER_CONFIGS_LOAD_COMPLETE = "@administrator/FATHER_CONFIGS_LOAD_COMPLETE",
  FATHER_CONFIGS_LOAD_ERROR = "@administrator/FATHER_CONFIGS_LOAD_ERROR",
  CONFIGS_SAVE_PROCESSING = "@administrator/CONFIGS_SAVE_PROCESSING",
  CONFIGS_SAVE_COMPLETE = "@administrator/CONFIGS_SAVE_COMPLETE",
  CONFIGS_SAVE_ERROR = "@administrator/CONFIGS_SAVE_ERROR",
  CONFIGS_IMAGE_SAVE_PROCESSING = "@administrator/CONFIGS_IMAGE_SAVE_PROCESSING",
  CONFIGS_IMAGE_SAVE_COMPLETE = "@administrator/CONFIGS_IMAGE_SAVE_COMPLETE",
  CONFIGS_IMAGE_SAVE_ERROR = "@administrator/CONFIGS_IMAGE_SAVE_ERROR",
  CONFIGS_IMAGE_GET_PROCESSING = "@administrator/CONFIGS_IMAGE_GET_PROCESSING",
  CONFIGS_IMAGE_GET_COMPLETE = "@administrator/CONFIGS_IMAGE_GET_COMPLETE",
  CONFIGS_IMAGE_GET_ERROR = "@administrator/CONFIGS_IMAGE_GET_ERROR",
  SHAPEFILE_SAVE_PROCESSING = "@administrator/SHAPEFILE_SAVE_PROCESSING",
  SHAPEFILE_SAVE_COMPLETE = "@administrator/SHAPEFILE_SAVE_COMPLETE",
  SHAPEFILE_SAVE_ERROR = "@administrator/SHAPEFILE_SAVE_ERROR",
  SHAPEFILES_LOAD_PROCESSING = "@administrator/SHAPEFILES_LOAD_PROCESSING",
  SHAPEFILES_LOAD_COMPLETE = "@administrator/SHAPEFILES_LOAD_COMPLETE",
  SHAPEFILES_LOAD_ERROR = "@administrator/SHAPEFILES_LOAD_ERROR",
  SHAPEFILE_DELETE_PROCESSING = "@administrator/SHAPEFILE_DELETE_PROCESSING",
  SHAPEFILE_DELETE_COMPLETE = "@administrator/SHAPEFILE_DELETE_COMPLETE",
  SHAPEFILE_DELETE_ERROR = "@administrator/SHAPEFILE_DELETE_ERROR",
  SEAT_LIMIT_CONFIG_SAVE_PROCESSING = "@administrator/SEAT_LIMIT_CONFIG_SAVE_PROCESSING",
  SEAT_LIMIT_CONFIG_SAVE_COMPLETE = "@administrator/SEAT_LIMIT_CONFIG_SAVE_COMPLETE",
  SEAT_LIMIT_CONFIG_SAVE_ERROR = "@administrator/SEAT_LIMIT_CONFIG_SAVE_ERROR",
  SEAT_LIMIT_CONFIGS_LOAD_PROCESSING = "@administrator/SEAT_LIMIT_CONFIGS_LOAD_PROCESSING",
  SEAT_LIMIT_CONFIGS_LOAD_COMPLETE = "@administrator/SEAT_LIMIT_CONFIGS_LOAD_COMPLETE",
  SEAT_LIMIT_CONFIGS_LOAD_ERROR = "@administrator/SEAT_LIMIT_CONFIGS_LOAD_ERROR",
  CLASSROOM_SIZE_CONFIG_SAVE_PROCESSING = "@administrator/CLASSROOM_SIZE_CONFIG_SAVE_PROCESSING",
  CLASSROOM_SIZE_CONFIG_SAVE_COMPLETE = "@administrator/CLASSROOM_SIZE_CONFIG_SAVE_COMPLETE",
  CLASSROOM_SIZE_CONFIG_SAVE_ERROR = "@administrator/CLASSROOM_SIZE_CONFIG_SAVE_ERROR",
  CLASSROOM_SIZE_CONFIGS_LOAD_PROCESSING = "@administrator/CLASSROOM_SIZE_CONFIGS_LOAD_PROCESSING",
  CLASSROOM_SIZE_CONFIGS_LOAD_COMPLETE = "@administrator/CLASSROOM_SIZE_CONFIGS_LOAD_COMPLETE",
  CLASSROOM_SIZE_CONFIGS_LOAD_ERROR = "@administrator/CLASSROOM_SIZE_CONFIGS_LOAD_ERROR",
  FEEDER_PATTERN_CONFIG_SAVE_PROCESSING = "@administrator/FEEDER_PATTERN_CONFIG_SAVE_PROCESSING",
  FEEDER_PATTERN_CONFIG_SAVE_COMPLETE = "@administrator/FEEDER_PATTERN_CONFIG_SAVE_COMPLETE",
  FEEDER_PATTERN_CONFIG_SAVE_ERROR = "@administrator/FEEDER_PATTERN_CONFIG_SAVE_ERROR",
  FEEDER_PATTERN_CONFIGS_LOAD_PROCESSING = "@administrator/FEEDER_PATTERN_CONFIGS_LOAD_PROCESSING",
  FEEDER_PATTERN_CONFIGS_LOAD_COMPLETE = "@administrator/FEEDER_PATTERN_CONFIGS_LOAD_COMPLETE",
  FEEDER_PATTERN_CONFIGS_LOAD_ERROR = "@administrator/FEEDER_PATTERN_CONFIGS_LOAD_ERROR",
  FEEDER_PATTERN_CONFIG_DELETE_PROCESSING = "@administrator/FEEDER_PATTERN_CONFIG_DELETE_PROCESSING",
  FEEDER_PATTERN_CONFIG_DELETE_COMPLETE = "@administrator/FEEDER_PATTERN_CONFIG_DELETE_COMPLETE",
  FEEDER_PATTERN_CONFIG_DELETE_ERROR = "@administrator/FEEDER_PATTERN_CONFIG_DELETE_ERROR",
  FEEDER_PATTERN_CONFIG_IMPORT_PROCESSING = "@administrator/FEEDER_PATTERN_CONFIG_IMPORT_PROCESSING",
  FEEDER_PATTERN_CONFIG_IMPORT_COMPLETE = "@administrator/FEEDER_PATTERN_CONFIG_IMPORT_COMPLETE",
  FEEDER_PATTERN_CONFIG_IMPORT_ERROR = "@administrator/FEEDER_PATTERN_CONFIG_IMPORT_ERROR",
  SCHOOL_DIRECTORY_LOAD_PROCESSING = "@administrator/SCHOOL_DIRECTORY_LOAD_PROCESSING",
  SCHOOL_DIRECTORY_LOAD_COMPLETE = "@administrator/SCHOOL_DIRECTORY_LOAD_COMPLETE",
  SCHOOL_DIRECTORY_LOAD_ERROR = "@administrator/SCHOOL_DIRECTORY_LOAD_ERROR",
  SCHOOL_DIRECTORY_SAVE_PROCESSING = "@administrator/SCHOOL_DIRECTORY_SAVE_PROCESSING",
  SCHOOL_DIRECTORY_SAVE_COMPLETE = "@administrator/SCHOOL_DIRECTORY_SAVE_COMPLETE",
  SCHOOL_DIRECTORY_SAVE_ERROR = "@administrator/SCHOOL_DIRECTORY_SAVE_ERROR",
  SCHOOL_DIRECTORY_BATCH_SAVE_PROCESSING = "@administrator/SCHOOL_DIRECTORY_BATCH_SAVE_PROCESSING",
  SCHOOL_DIRECTORY_BATCH_SAVE_COMPLETE = "@administrator/SCHOOL_DIRECTORY_BATCH_SAVE_COMPLETE",
  SCHOOL_DIRECTORY_BATCH_SAVE_ERROR = "@administrator/SCHOOL_DIRECTORY_BATCH_SAVE_ERROR",
  SCHOOL_DIRECTORY_DELETE_PROCESSING = "@administrator/SCHOOL_DIRECTORY_DELETE_PROCESSING",
  SCHOOL_DIRECTORY_DELETE_COMPLETE = "@administrator/SCHOOL_DIRECTORY_DELETE_COMPLETE",
  SCHOOL_DIRECTORY_DELETE_ERROR = "@administrator/SCHOOL_DIRECTORY_DELETE_ERROR",
  PROGRAM_CODES_LOAD_PROCESSING = "@administrator/PROGRAM_CODES_LOAD_PROCESSING",
  PROGRAM_CODES_LOAD_COMPLETE = "@administrator/PROGRAM_CODES_LOAD_COMPLETE",
  PROGRAM_CODES_LOAD_ERROR = "@administrator/PROGRAM_CODES_LOAD_ERROR",
  PROGRAM_CODES_SAVE_PROCESSING = "@administrator/PROGRAM_CODES_SAVE_PROCESSING",
  PROGRAM_CODES_SAVE_COMPLETE = "@administrator/PROGRAM_CODES_SAVE_COMPLETE",
  PROGRAM_CODES_SAVE_ERROR = "@administrator/PROGRAM_CODES_SAVE_ERROR",
}

export const loadOrganizations = (user: User) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { administratorInteractor: AdministratorInteractor }
  ) => {
    dispatch({ type: ActionTypes.ORGANIZATIONS_LOAD_PROCESSING });
    try {
      dispatch({
        type: ActionTypes.ORGANIZATIONS_LOAD_COMPLETE,
        payload: await deps.administratorInteractor.getOrganizations(user),
      });
    } catch (error) {
      dispatch({ type: ActionTypes.ORGANIZATIONS_LOAD_ERROR, payload: error });
    }
  };
};

export const saveOrganizations = (org: Organization) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { administratorInteractor: AdministratorInteractor }
  ) => {
    dispatch({ type: ActionTypes.ORGANIZATIONS_SAVE_PROCESSING });
    try {
      dispatch({
        type: ActionTypes.ORGANIZATIONS_SAVE_COMPLETE,
        payload: await deps.administratorInteractor.saveOrganizations(org),
      });
    } catch (error) {
      dispatch({ type: ActionTypes.ORGANIZATIONS_SAVE_ERROR, payload: error });
    }
  };
};

export const getOrganization = (orgId: string) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { administratorInteractor: AdministratorInteractor }
  ) => {
    dispatch({ type: ActionTypes.ORGANIZATION_GET_PROCESSING });
    try {
      dispatch({
        type: ActionTypes.ORGANIZATION_GET_COMPLETE,
        payload: await deps.administratorInteractor.getOrganization(orgId),
      });
    } catch (error) {
      console.log("ERRORRL:", error);
      dispatch({
        type: ActionTypes.ORGANIZATION_GET_ERROR,
        payload: error,
      });
    }
  };
};

export const getOrganizationLogin = (
  orgId: string,
  loggedUserArray: User[]
) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { administratorInteractor: AdministratorInteractor }
  ) => {
    dispatch({ type: ActionTypes.ORGANIZATION_GET_LOGIN_PROCESSING });
    try {
      dispatch({
        type: ActionTypes.ORGANIZATION_GET_LOGIN_COMPLETE,
        payload: {
          loggedUserArray: loggedUserArray,
          orgDetails: await deps.administratorInteractor.getOrganization(orgId),
        },
      });
    } catch (error) {
      console.log("ERRORRL:", error);
      dispatch({
        type: ActionTypes.ORGANIZATION_GET_LOGIN_ERROR,
        payload: error,
      });
    }
  };
};

export const deleteOrganization = (orgId: string) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { administratorInteractor: AdministratorInteractor }
  ) => {
    dispatch({ type: ActionTypes.ORGANIZATION_DELETE_PROCESSING });
    try {
      dispatch({
        type: ActionTypes.ORGANIZATION_DELETE_COMPLETE,
        payload: await deps.administratorInteractor.deleteOrganization(orgId),
      });
    } catch (error) {
      console.log("ERRORRL:", error);
      dispatch({
        type: ActionTypes.ORGANIZATION_DELETE_ERROR,
        payload: error,
      });
    }
  };
};

export const getOrganizationByURl = (orgUrl: string) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { administratorInteractor: AdministratorInteractor }
  ) => {
    dispatch({ type: ActionTypes.ORGANIZATIONS_GET_BYURL_PROCESSING });
    try {
      dispatch({
        type: ActionTypes.ORGANIZATIONS_GET_BYURL_COMPLETE,
        payload: await deps.administratorInteractor.getOrganizationByURl(
          orgUrl
        ),
      });
    } catch (error) {
      console.log("ERRORRL:", error);
      dispatch({
        type: ActionTypes.ORGANIZATIONS_GET_BYURL_ERROR,
        payload: error,
      });
    }
  };
};

export const loadUserByShortId = (shortId: string) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { administratorInteractor: AdministratorInteractor }
  ) => {
    dispatch({ type: ActionTypes.USER_LOAD_BY_EMAIL_PROCESSING });
    try {
      dispatch({
        type: ActionTypes.USER_LOAD_BY_EMAIL_COMPLETE,
        payload: await deps.administratorInteractor.getUserByShortId(shortId),
      });
    } catch (error) {
      dispatch({
        type: ActionTypes.USER_LOAD_BY_EMAIL_ERROR,
        payload: error,
      });
    }
  };
};

export const loadUserByEmail = (organizationId: string, email: string) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { administratorInteractor: AdministratorInteractor }
  ) => {
    dispatch({ type: ActionTypes.USER_LOAD_BY_EMAIL_PROCESSING });
    try {
      dispatch({
        type: ActionTypes.USER_LOAD_BY_EMAIL_COMPLETE,
        payload: await deps.administratorInteractor.getUserByEmail(organizationId, email),
      });
    } catch (error) {
      dispatch({
        type: ActionTypes.USER_LOAD_BY_EMAIL_ERROR,
        payload: error,
      });
    }
  };
};

export const loadUsers = (user: User) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { administratorInteractor: AdministratorInteractor }
  ) => {
    dispatch({ type: ActionTypes.USERS_LOAD_PROCESSING });
    try {
      dispatch({
        type: ActionTypes.USERS_LOAD_COMPLETE,
        payload: await deps.administratorInteractor.getUsers(user),
      });
    } catch (error) {
      dispatch({ type: ActionTypes.USERS_LOAD_ERROR, payload: error });
    }
  };
};

export const saveUser = (user: User, userToSave: User) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { administratorInteractor: AdministratorInteractor }
  ) => {
    dispatch({ type: ActionTypes.USER_SAVE_PROCESSING });
    try {
      dispatch({
        type: ActionTypes.USER_SAVE_COMPLETE,
        payload: await deps.administratorInteractor.saveUser(user, userToSave),
      });
    } catch (error) {
      dispatch({ type: ActionTypes.USER_SAVE_ERROR, payload: error });
    }
  };
};

export const resendCognito_UserDetail = (
  userid: string,
  organizationId: string,
  email: string
) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { administratorInteractor: AdministratorInteractor }
  ) => {
    dispatch({ type: ActionTypes.USER_COGNITO_SAVE_PROCESSING });
    try {
      // The temporary password is generated server-side and emailed to the
      // user; it never passes through the client.
      dispatch({
        type: ActionTypes.USER_COGNITO_SAVE_COMPLETE,
        payload: await deps.administratorInteractor.cognitoResendUser(
          userid,
          organizationId,
          email
        ),
      });
    } catch (error) {
      dispatch({ type: ActionTypes.USER_COGNITO_SAVE_ERROR, payload: error });
    }
  };
};

export const cognitoCheckUserExist = (email: string) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { administratorInteractor: AdministratorInteractor }
  ) => {
    dispatch({ type: ActionTypes.COGNITO_USER_CHECK_PROCESSING });

    try {
      const result = await deps.administratorInteractor.cognitoCheckUserExist(email); 
      dispatch({
        type: ActionTypes.COGNITO_USER_CHECK_COMPLETE,
        payload: result,
      });
      return result;
    } catch (error) {
      dispatch({
        type: ActionTypes.COGNITO_USER_CHECK_ERROR,
        payload: error,
      });
      return false;
    }
  };
};

export const saveUserCognito = (
  userid: string,
  organizationId: string,
  email: string
) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { administratorInteractor: AdministratorInteractor }
  ) => {
    dispatch({ type: ActionTypes.USER_COGNITO_SAVE_PROCESSING });
    try {
      // The temporary password is generated server-side and emailed to the
      // user; it never passes through the client.
      dispatch({
        type: ActionTypes.USER_COGNITO_SAVE_COMPLETE,
        payload: await deps.administratorInteractor.cognitoCreateUser(
          userid,
          organizationId,
          email
        ),
      });
    } catch (error) {
      dispatch({ type: ActionTypes.USER_COGNITO_SAVE_ERROR, payload: error });
    }
  };
};

export const deleteUser = (user: User, userToDelete: User) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { administratorInteractor: AdministratorInteractor }
  ) => {
    dispatch({ type: ActionTypes.USER_DELETE_PROCESSING });
    try {
      dispatch({
        type: ActionTypes.USER_DELETE_COMPLETE,
        payload: await deps.administratorInteractor.deleteUser(
          user,
          userToDelete
        ),
      });
    } catch (error) {
      dispatch({ type: ActionTypes.USER_DELETE_ERROR, payload: error });
    }
  };
};

export const registerUser = (
  firstName: string,
  lastName: string,
  email: string,
  password: string,
  orgName: string,
  phoneNumber?: string,
  smsConsent?: boolean
) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { administratorInteractor: AdministratorInteractor }
  ) => {
    dispatch({ type: ActionTypes.USER_REGISTER_PROCESSING });
    try {
      dispatch({
        type: ActionTypes.USER_REGISTER_COMPLETE,
        payload: await deps.administratorInteractor.registerUser(
          firstName,
          lastName,
          email,
          password,
          orgName,
          phoneNumber,
          smsConsent
        ),
      });
    } catch (error) {
      dispatch({ type: ActionTypes.USER_REGISTER_ERROR, payload: error });
    }
  };
};

export const loadRoles = (user: User) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { administratorInteractor: AdministratorInteractor }
  ) => {
    dispatch({ type: ActionTypes.ROLES_LOAD_PROCESSING });
    try {
      dispatch({
        type: ActionTypes.ROLES_LOAD_COMPLETE,
        payload: await deps.administratorInteractor.getRoles(user),
      });
    } catch (error) {
      dispatch({ type: ActionTypes.ROLES_LOAD_ERROR, payload: error });
    }
  };
};

export const loadPermissionTypes = (user: User) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { administratorInteractor: AdministratorInteractor }
  ) => {
    dispatch({ type: ActionTypes.PERMISSIONTYPES_LOAD_PROCESSING });
    try {
      dispatch({
        type: ActionTypes.PERMISSIONTYPES_LOAD_COMPLETE,
        payload: await deps.administratorInteractor.getPermissionTypes(user),
      });
    } catch (error) {
      dispatch({
        type: ActionTypes.PERMISSIONTYPES_LOAD_ERROR,
        payload: error,
      });
    }
  };
};

export const loadPermissions = (
  user: User,
  documentTemplate: DocumentTemplate
) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { administratorInteractor: AdministratorInteractor }
  ) => {
    dispatch({ type: ActionTypes.PERMISSIONS_LOAD_PROCESSING });
    try {
      dispatch({
        type: ActionTypes.PERMISSIONS_LOAD_COMPLETE,
        payload: await deps.administratorInteractor.getPermissions(
          user,
          documentTemplate
        ),
      });
    } catch (error) {
      dispatch({ type: ActionTypes.PERMISSIONS_LOAD_ERROR, payload: error });
    }
  };
};

export const savePermission = (user: User, permission: Permission) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { administratorInteractor: AdministratorInteractor }
  ) => {
    dispatch({ type: ActionTypes.PERMISSIONS_LOAD_PROCESSING });
    try {
      dispatch({
        type: ActionTypes.PERMISSIONS_LOAD_COMPLETE,
        payload: await deps.administratorInteractor.savePermission(
          user,
          permission
        ),
      });
    } catch (error) {
      dispatch({ type: ActionTypes.PERMISSIONS_LOAD_ERROR, payload: error });
    }
  };
};

export const loadConfigs = (orgId: string, page: string) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { administratorInteractor: AdministratorInteractor }
  ) => {
    dispatch({ type: ActionTypes.CONFIGS_LOAD_PROCESSING });
    try {
      dispatch({
        type: ActionTypes.CONFIGS_LOAD_COMPLETE,
        payload: {
          config: await deps.administratorInteractor.getSiteConfigs(
            orgId,
            page
          ),
          page: page,
        },
      });
    } catch (error) {
      dispatch({ type: ActionTypes.CONFIGS_LOAD_ERROR, payload: error });
    }
  };
};
export const loadFatherConfigs = (orgId: string, page: string) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { administratorInteractor: AdministratorInteractor }
  ) => {
    dispatch({ type: ActionTypes.FATHER_CONFIGS_LOAD_PROCESSING });
    try {
      dispatch({
        type: ActionTypes.FATHER_CONFIGS_LOAD_COMPLETE,
        payload: {
          config: await deps.administratorInteractor.getSiteConfigs(
            orgId,
            page
          ),
          page: page,
        },
      });
    } catch (error) {
      dispatch({ type: ActionTypes.FATHER_CONFIGS_LOAD_ERROR, payload: error });
    }
  };
};

export const saveConfigs = (
  orgId: string,
  page: ConfigPageIndex,
  siteConfigs: SiteConfigs
) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { administratorInteractor: AdministratorInteractor }
  ) => {
    dispatch({ type: ActionTypes.CONFIGS_SAVE_PROCESSING });
    try {
      dispatch({
        type: ActionTypes.CONFIGS_SAVE_COMPLETE,
        payload: {
          config: await deps.administratorInteractor.saveSiteConfigs(
            orgId,
            page,
            siteConfigs
          ),
          page: page,
        },
      });
    } catch (error) {
      dispatch({ type: ActionTypes.CONFIGS_SAVE_ERROR, payload: error });
    }
  };
};

export const saveImage = (orgId: string, fileName: string, file: File) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { administratorInteractor: AdministratorInteractor }
  ) => {
    dispatch({ type: ActionTypes.CONFIGS_IMAGE_SAVE_PROCESSING });
    try {
      dispatch({
        type: ActionTypes.CONFIGS_IMAGE_SAVE_COMPLETE,
        payload: {
          result: await deps.administratorInteractor.saveImage(
            orgId,
            fileName,
            file
          ),
          fileName: fileName,
          file: file,
        },
      });
    } catch (error) {
      dispatch({ type: ActionTypes.CONFIGS_IMAGE_SAVE_ERROR, payload: error });
    }
  };
};

export const getImage = (orgId: string, fileName: string) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { administratorInteractor: AdministratorInteractor }
  ) => {
    dispatch({ type: ActionTypes.CONFIGS_IMAGE_GET_PROCESSING });
    try {
      dispatch({
        type: ActionTypes.CONFIGS_IMAGE_GET_COMPLETE,
        payload: {
          file: await deps.administratorInteractor.getImage(orgId, fileName),
          fileName: fileName,
        },
      });
    } catch (error) {
      dispatch({ type: ActionTypes.CONFIGS_IMAGE_GET_ERROR, payload: error });
    }
  };
};

export const saveShapefiles = (organizationId: string, shapes: ZoneShape[]) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { administratorInteractor: AdministratorInteractor }
  ) => {
    dispatch({ type: ActionTypes.SHAPEFILE_SAVE_PROCESSING });
    try {
      dispatch({
        type: ActionTypes.SHAPEFILE_SAVE_COMPLETE,
        payload: await deps.administratorInteractor.saveShapefiles(organizationId, shapes),
      });
    } catch (error) {
      dispatch({ type: ActionTypes.SHAPEFILE_SAVE_ERROR, payload: error });
    }
  };
};

export const updateShapefileName = (organizationId: string, shapefileId: string, name: string) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { administratorInteractor: AdministratorInteractor }
  ) => {
    dispatch({ type: ActionTypes.SHAPEFILE_SAVE_PROCESSING });
    try {
      await deps.administratorInteractor.updateShapefileName(organizationId, shapefileId, name);
      dispatch({ type: ActionTypes.SHAPEFILE_SAVE_COMPLETE, payload: [] });
    } catch (error) {
      dispatch({ type: ActionTypes.SHAPEFILE_SAVE_ERROR, payload: error });
    }
  };
};

export const updateShapefileTags = (organizationId: string, shapefileId: string, tags: ShapefileTag[]) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { administratorInteractor: AdministratorInteractor }
  ) => {
    dispatch({ type: ActionTypes.SHAPEFILE_SAVE_PROCESSING });
    try {
      await deps.administratorInteractor.updateShapefileTags(organizationId, shapefileId, tags);
      dispatch({ type: ActionTypes.SHAPEFILE_SAVE_COMPLETE, payload: [] });
    } catch (error) {
      dispatch({ type: ActionTypes.SHAPEFILE_SAVE_ERROR, payload: error });
    }
  };
};

export const updateShapefileDescription = (organizationId: string, shapefileId: string, description: string) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { administratorInteractor: AdministratorInteractor }
  ) => {
    dispatch({ type: ActionTypes.SHAPEFILE_SAVE_PROCESSING });
    try {
      await deps.administratorInteractor.updateShapefileDescription(organizationId, shapefileId, description);
      dispatch({ type: ActionTypes.SHAPEFILE_SAVE_COMPLETE, payload: [] });
    } catch (error) {
      dispatch({ type: ActionTypes.SHAPEFILE_SAVE_ERROR, payload: error });
    }
  };
};

export const loadShapefiles = (organizationId: string) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { administratorInteractor: AdministratorInteractor }
  ) => {
    dispatch({ type: ActionTypes.SHAPEFILES_LOAD_PROCESSING });
    try {
      dispatch({
        type: ActionTypes.SHAPEFILES_LOAD_COMPLETE,
        payload: await deps.administratorInteractor.loadShapefilesList(organizationId),
      });
    } catch (err) {
      dispatch({
        type: ActionTypes.SHAPEFILES_LOAD_ERROR,
        payload: err,
      });
    }
  };
};

export const loadShapefileGeometry = (organizationId: string, shapefileId: string) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { administratorInteractor: AdministratorInteractor }
  ) => {
    return await deps.administratorInteractor.loadShapefileGeometry(organizationId, shapefileId);
  };
};

export const saveShapefileAndReturn = (organizationId: string, shapes: ZoneShape[]) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { administratorInteractor: AdministratorInteractor }
  ) => {
    return await deps.administratorInteractor.saveShapefiles(organizationId, shapes);
  };
};

export const deleteShapefile = (organizationId: string, shapefileId: string) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { administratorInteractor: AdministratorInteractor }
  ) => {
    dispatch({ type: ActionTypes.SHAPEFILE_DELETE_PROCESSING });
    try {
      dispatch({
        type: ActionTypes.SHAPEFILE_DELETE_COMPLETE,
        payload: await deps.administratorInteractor.deleteShapefile(organizationId, shapefileId),
      });
    } catch (err) {
      dispatch({
        type: ActionTypes.SHAPEFILE_DELETE_ERROR,
        payload: err,
      });
    }
  };
};

export const saveSeatLimitConfig = (seatLimitConfig: SeatLimitConfig) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { administratorInteractor: AdministratorInteractor }
  ) => {
    dispatch({ type: ActionTypes.SEAT_LIMIT_CONFIG_SAVE_PROCESSING });
    try {
      dispatch({
        type: ActionTypes.SEAT_LIMIT_CONFIG_SAVE_COMPLETE,
        payload: await deps.administratorInteractor.saveSeatLimitConfig(seatLimitConfig),
      });
    } catch (error) {
      dispatch({ type: ActionTypes.SEAT_LIMIT_CONFIG_SAVE_ERROR, payload: error });
    }
  };
};

export const loadSeatLimitConfigs = (organizationId: string) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { administratorInteractor: AdministratorInteractor }
  ) => {
    dispatch({ type: ActionTypes.SEAT_LIMIT_CONFIGS_LOAD_PROCESSING });
    try {
      dispatch({
        type: ActionTypes.SEAT_LIMIT_CONFIGS_LOAD_COMPLETE,
        payload: await deps.administratorInteractor.getSeatLimitConfigs(organizationId),
      });
    } catch (err) {
      dispatch({
        type: ActionTypes.SEAT_LIMIT_CONFIGS_LOAD_ERROR,
        payload: err,
      });
    }
  };
};

export const saveClassroomSizeConfig = (classroomSizeConfig: ClassroomSizeConfig) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { administratorInteractor: AdministratorInteractor }
  ) => {
    dispatch({ type: ActionTypes.CLASSROOM_SIZE_CONFIG_SAVE_PROCESSING });
    try {
      dispatch({
        type: ActionTypes.CLASSROOM_SIZE_CONFIG_SAVE_COMPLETE,
        payload: await deps.administratorInteractor.saveClassroomSizeConfig(classroomSizeConfig),
      });
    } catch (error) {
      dispatch({ type: ActionTypes.CLASSROOM_SIZE_CONFIG_SAVE_ERROR, payload: error });
    }
  };
};

export const loadClassroomSizeConfigs = (organizationId: string) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { administratorInteractor: AdministratorInteractor }
  ) => {
    dispatch({ type: ActionTypes.CLASSROOM_SIZE_CONFIGS_LOAD_PROCESSING });
    try {
      dispatch({
        type: ActionTypes.CLASSROOM_SIZE_CONFIGS_LOAD_COMPLETE,
        payload: await deps.administratorInteractor.getClassroomSizeConfigs(organizationId),
      });
    } catch (err) {
      dispatch({
        type: ActionTypes.CLASSROOM_SIZE_CONFIGS_LOAD_ERROR,
        payload: err,
      });
    }
  };
};

export const saveFeederPatternConfig = (feederPatternConfig: FeederPatternConfig) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { administratorInteractor: AdministratorInteractor }
  ) => {
    dispatch({ type: ActionTypes.FEEDER_PATTERN_CONFIG_SAVE_PROCESSING });
    try {
      dispatch({
        type: ActionTypes.FEEDER_PATTERN_CONFIG_SAVE_COMPLETE,
        payload: await deps.administratorInteractor.saveFeederPatternConfig(feederPatternConfig),
      });
    } catch (error) {
      dispatch({ type: ActionTypes.FEEDER_PATTERN_CONFIG_SAVE_ERROR, payload: error });
    }
  };
};

export const loadFeederPatternConfigs = (organizationId: string) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { administratorInteractor: AdministratorInteractor }
  ) => {
    dispatch({ type: ActionTypes.FEEDER_PATTERN_CONFIGS_LOAD_PROCESSING });
    try {
      dispatch({
        type: ActionTypes.FEEDER_PATTERN_CONFIGS_LOAD_COMPLETE,
        payload: await deps.administratorInteractor.getFeederPatternConfigs(organizationId),
      });
    } catch (err) {
      dispatch({
        type: ActionTypes.FEEDER_PATTERN_CONFIGS_LOAD_ERROR,
        payload: err,
      });
    }
  };
};

export const deleteFeederPatternConfig = (organizationId: string, feederPatternId: string) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { administratorInteractor: AdministratorInteractor }
  ) => {
    dispatch({ type: ActionTypes.FEEDER_PATTERN_CONFIG_DELETE_PROCESSING });
    try {
      await deps.administratorInteractor.deleteFeederPatternConfig(organizationId, feederPatternId);
      dispatch({
        type: ActionTypes.FEEDER_PATTERN_CONFIG_DELETE_COMPLETE,
        payload: feederPatternId,
      });
    } catch (error) {
      dispatch({ type: ActionTypes.FEEDER_PATTERN_CONFIG_DELETE_ERROR, payload: error });
    }
  };
};

export const importFeederPatternConfigs = (organizationId: string, configs: FeederPatternConfig[]) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { administratorInteractor: AdministratorInteractor }
  ) => {
    dispatch({ type: ActionTypes.FEEDER_PATTERN_CONFIG_IMPORT_PROCESSING });
    try {
      const result = await deps.administratorInteractor.importFeederPatternConfigs(organizationId, configs);
      dispatch({
        type: ActionTypes.FEEDER_PATTERN_CONFIG_IMPORT_COMPLETE,
        payload: result,
      });
      // Reload configs after import
      dispatch({ type: ActionTypes.FEEDER_PATTERN_CONFIGS_LOAD_PROCESSING } as any);
      const loaded = await deps.administratorInteractor.getFeederPatternConfigs(organizationId);
      dispatch({
        type: ActionTypes.FEEDER_PATTERN_CONFIGS_LOAD_COMPLETE,
        payload: loaded,
      } as any);
    } catch (error) {
      dispatch({ type: ActionTypes.FEEDER_PATTERN_CONFIG_IMPORT_ERROR, payload: error });
    }
  };
};

export const loadSchoolDirectory = (organizationId: string, forceRefresh = false) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { administratorInteractor: AdministratorInteractor }
  ) => {
    const { schoolDirectoryLoadStatus } = getState().administrator;
    if (!forceRefresh && schoolDirectoryLoadStatus === StateStatus.COMPLETE) return;

    dispatch({ type: ActionTypes.SCHOOL_DIRECTORY_LOAD_PROCESSING });
    try {
      dispatch({
        type: ActionTypes.SCHOOL_DIRECTORY_LOAD_COMPLETE,
        payload: await deps.administratorInteractor.getSchoolDirectory(organizationId),
      });
    } catch (err) {
      dispatch({
        type: ActionTypes.SCHOOL_DIRECTORY_LOAD_ERROR,
        payload: err,
      });
    }
  };
};

export const loadProgramCodes = (organizationId: string, forceRefresh = false) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { administratorInteractor: AdministratorInteractor }
  ) => {
    const { programCodesLoadStatus } = getState().administrator;
    if (
      !forceRefresh &&
      (programCodesLoadStatus === StateStatus.COMPLETE ||
        programCodesLoadStatus === StateStatus.LOADING)
    )
      return;

    dispatch({ type: ActionTypes.PROGRAM_CODES_LOAD_PROCESSING });
    try {
      dispatch({
        type: ActionTypes.PROGRAM_CODES_LOAD_COMPLETE,
        payload: await deps.administratorInteractor.getSiteConfigs(
          organizationId,
          ConfigPageIndex.PROGRAM_CODES
        ),
      });
    } catch (err) {
      dispatch({ type: ActionTypes.PROGRAM_CODES_LOAD_ERROR, payload: err });
    }
  };
};

export const saveProgramCodes = (
  organizationId: string,
  codes: Record<string, string>
) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { administratorInteractor: AdministratorInteractor }
  ) => {
    dispatch({ type: ActionTypes.PROGRAM_CODES_SAVE_PROCESSING });
    try {
      dispatch({
        type: ActionTypes.PROGRAM_CODES_SAVE_COMPLETE,
        payload: await deps.administratorInteractor.saveSiteConfigs(
          organizationId,
          ConfigPageIndex.PROGRAM_CODES,
          codes as unknown as SiteConfigs
        ),
      });
    } catch (error) {
      dispatch({ type: ActionTypes.PROGRAM_CODES_SAVE_ERROR, payload: error });
    }
  };
};

export const saveSchoolDirectoryEntry = (organizationId: string, entry: SchoolDirectoryEntry) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { administratorInteractor: AdministratorInteractor }
  ) => {
    dispatch({ type: ActionTypes.SCHOOL_DIRECTORY_SAVE_PROCESSING });
    try {
      dispatch({
        type: ActionTypes.SCHOOL_DIRECTORY_SAVE_COMPLETE,
        payload: await deps.administratorInteractor.saveSchoolDirectoryEntry(organizationId, entry),
      });
    } catch (error) {
      dispatch({ type: ActionTypes.SCHOOL_DIRECTORY_SAVE_ERROR, payload: error });
    }
  };
};

export const saveSchoolDirectoryBatch = (organizationId: string, entries: SchoolDirectoryEntry[]) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { administratorInteractor: AdministratorInteractor }
  ) => {
    dispatch({ type: ActionTypes.SCHOOL_DIRECTORY_BATCH_SAVE_PROCESSING });
    try {
      dispatch({
        type: ActionTypes.SCHOOL_DIRECTORY_BATCH_SAVE_COMPLETE,
        payload: await deps.administratorInteractor.saveSchoolDirectoryBatch(organizationId, entries),
      });
    } catch (error) {
      dispatch({ type: ActionTypes.SCHOOL_DIRECTORY_BATCH_SAVE_ERROR, payload: error });
    }
  };
};

export const deleteSchoolDirectoryEntry = (organizationId: string, schoolId: string) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { administratorInteractor: AdministratorInteractor }
  ) => {
    dispatch({ type: ActionTypes.SCHOOL_DIRECTORY_DELETE_PROCESSING });
    try {
      await deps.administratorInteractor.deleteSchoolDirectoryEntry(organizationId, schoolId);
      dispatch({
        type: ActionTypes.SCHOOL_DIRECTORY_DELETE_COMPLETE,
        payload: schoolId,
      });
    } catch (error) {
      dispatch({ type: ActionTypes.SCHOOL_DIRECTORY_DELETE_ERROR, payload: error });
    }
  };
};